"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DXAccountContext = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _authorization = require("dx-sdk/build/authorization");

var _services = require("dx-sdk/build/services");

var _config = require("../utils/config");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//Creating a default context for server side.
var DXAccountContext = /*#__PURE__*/(0, _react.createContext)({
  state: {
    account: null,
    email: null,
    fetchingAccount: true,
    redirectPath: null,
    postLoginRedirectPath: null
  },
  actions: {}
});
exports.DXAccountContext = DXAccountContext;

var DXAccountContextProvider = function DXAccountContextProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      account = _useState2[0],
      setAccount = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      email = _useState4[0],
      setEmail = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      token = _useState6[0],
      setToken = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      error = _useState8[0],
      setError = _useState8[1];

  var _useAuthorization = (0, _authorization.useAuthorization)(),
      isAuthenticated = _useAuthorization.isAuthenticated,
      loginWithPopup = _useAuthorization.loginWithPopup,
      logout = _useAuthorization.logout,
      user = _useAuthorization.user,
      getAccessTokenSilently = _useAuthorization.getAccessTokenSilently;

  var userService = (0, _services.useUserService)(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    token: token,
    user: user ? {
      identityProviderUserId: user === null || user === void 0 ? void 0 : user.sub,
      identityProviderId: 1
    } : null
  }, (user === null || user === void 0 ? void 0 : user.given_name) && {
    firstName: user.given_name
  }), (user === null || user === void 0 ? void 0 : user.first_name) && {
    firstName: user.first_name
  }), (user === null || user === void 0 ? void 0 : user.family_name) && {
    lastName: user.family_name
  }), (user === null || user === void 0 ? void 0 : user.last_name) && {
    lastName: user.last_name
  }), {}, {
    profile: {
      profileType: 'corp'
    },
    include: {
      corpCollections: true
    }
  })); //We start the context by searching for the account with useEffect.

  var _useState9 = (0, _react.useState)(true),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      fetchingAccount = _useState10[0],
      setFetchingAccount = _useState10[1];

  var _useState11 = (0, _react.useState)(),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      redirectPath = _useState12[0],
      setRedirectPath = _useState12[1];

  var _useState13 = (0, _react.useState)(),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      postLoginRedirectPath = _useState14[0],
      setPostLoginRedirectPath = _useState14[1];

  (0, _react.useEffect)(function () {
    if (user) {
      getAccessTokenSilently().then(setToken).catch(setError);
    }
  }, [user, error, getAccessTokenSilently]);
  (0, _react.useEffect)(function () {
    if (isAuthenticated && !userService.loading && userService.data) {
      userService.data !== account ? setAccount(userService.data) : null;
      setEmail(user.email);
    }
  }, [userService.data, account]); //eslint-disable-line

  /**
   * Attempting a redirect directly through window.
   * If href set in <a> tag, code will immediately redirect before
   * login process completes causing an incomplete account state
   */

  (0, _react.useEffect)(function () {
    account && redirectPath ? window.location.href = "".concat((0, _config.getSiteUrl)()).concat(redirectPath) : null;
  }, [account, redirectPath]); //eslint-disable-line

  var actions = {
    accountLogin: function accountLogin() {
      isAuthenticated !== null && isAuthenticated !== void 0 ? isAuthenticated : actions.setUserAccount();
      return loginWithPopup();
    },
    accountSignup: function accountSignup() {
      isAuthenticated !== null && isAuthenticated !== void 0 ? isAuthenticated : actions.setUserAccount();
      return loginWithPopup({
        screen_hint: 'signup'
      });
    },
    setUserAccount: function setUserAccount() {
      setAccount(userService.data);
      user.email && setEmail(user.email);
      setFetchingAccount(false);
    },
    navigateToPortal: function navigateToPortal(path) {
      if (!account) {
        actions.accountLogin();
      }

      setRedirectPath(path);
    },
    updateAccount: function updateAccount(firstName, lastName, phone, pronouns, zip) {
      userService.patch({
        user: user ? {
          userId: Number(account.userId),
          firstName: firstName,
          lastName: lastName,
          phone: phone,
          preferredPronouns: pronouns,
          zipcode: zip
        } : null
      });
    },
    updateProfile: function updateProfile(profile) {
      userService.patchProfile({
        profile: profile
      });
    },
    accountLogout: function accountLogout() {
      if (typeof window !== 'undefined') {
        window.analytics.track('Log Out', {
          type: 'corp'
        });
      }

      setAccount([]);
      setEmail();
      setFetchingAccount(true);
      setRedirectPath();
      logout({
        returnTo: typeof window !== 'undefined' ? window.location.origin : '/'
      });
    },
    setPostLoginRedirectPath: setPostLoginRedirectPath
  };
  var currentContext = {
    state: {
      account: account,
      email: email,
      fetchingAccount: fetchingAccount,
      redirectPath: redirectPath,
      postLoginRedirectPath: postLoginRedirectPath
    },
    actions: actions
  };
  return /*#__PURE__*/_react.default.createElement(DXAccountContext.Provider, {
    value: currentContext
  }, children);
};

var _default = /*#__PURE__*/_react.default.memo(DXAccountContextProvider);

exports.default = _default;